import { render, staticRenderFns } from "./RdvsLightList.vue?vue&type=template&id=408d7bf4&"
import script from "./RdvsLightList.vue?vue&type=script&lang=js&"
export * from "./RdvsLightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports